module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "pad-top"
  }), _c('transition', {
    attrs: {
      "name": "swoosh"
    }
  }, [(!_vm.loadCompleted) ? _c('swoosh-icon', {
    staticClass: "swoosh"
  }) : _vm._e()], 1), _c('loading-text', {
    attrs: {
      "completed": _vm.loadCompleted
    }
  }), _c('div', {
    staticClass: "bottom"
  }, [_c('transition', {
    attrs: {
      "name": "load-section"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadCompleted),
      expression: "!loadCompleted"
    }]
  }, [_c('progress-bar', {
    attrs: {
      "time": _vm.updateTime,
      "progress": _vm.showProgress
    }
  })], 1)]), _c('transition', {
    attrs: {
      "name": "load-section"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadCompleted),
      expression: "loadCompleted"
    }]
  }, [_c('button', {
    staticClass: "start",
    on: {
      "click": _vm.next
    }
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("assets/result/btn-blue.png")
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('startCta')))])])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "lines"
  }, [_c('ul', [_c('li', {
    staticClass: "lines-bg"
  }), _c('li', {
    staticClass: "lines-bg"
  })])]), _c('div', {
    staticClass: "overlay"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e063d0c"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/Loading.vue
// module id = 422
// module chunks = 1